import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    CoverageListDto,
    CreateCoverageEntryDto,
    UpdateCoverageEntryDto,
} from '../../../core/data/new-dtos/insurance-type.dtos';
@Injectable({
    providedIn: 'root',
})
export class CoveragesService {
    private baseUrl = 'Coverages';

    constructor(private http: HttpClient) { }

    getAll(): Observable<CoverageListDto[]> {
        return this.http.get<CoverageListDto[]>(this.baseUrl);
    }

    create(dto: CreateCoverageEntryDto): Observable<number> {
        return this.http.post<number>(this.baseUrl, dto);
    }

    update(id: number, dto: UpdateCoverageEntryDto): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/${id}`, dto);
    }
}
